import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form';

import MembershipPlanFormProvider from '../../../../UI/Form/MembershipPlanForm/MembershipPlanFormProvider';
import { FormColumn } from '../../../../UI/Form/FormColumn/FormColumn';
import { BasicFormWrapper } from '../../../../Form/Form';
import { SectionSubTitle } from '../../../../Typography/Typography';

import {
  getFieldPropertiesForGroup,
  getFormGroupPath,
} from '../../../../../utils/getFormGroupPath';
import { SubscriptionItemBaseProps } from '../../../SubscriptionItemForm/subscriptionItemForm.models';
import { PricingMode } from '../../../../../models/enums/PricingMode';
import { useSRSubscriptionPricingForm } from './srSubscriptionPricingForm.hooks';
import {
  SRSubscriptionPricingFormFields,
  SRSubscriptionPricingFormName,
} from './srSubscriptionPricingForm.models';
import { Description } from './srSubscriptionPricingForm.styles';
import SRSubscriptionMembershipPlanForm from '../SRSubscriptionMembershipPlanForm/SRSubscriptionMembershipPlanForm';

const SRSubscriptionPricingForm = ({
  className,
  disabled,
  name,
  isEditMode,
}: SubscriptionItemBaseProps) => {
  const { t } = useTranslation();
  const { membershipPlansPrices, subscriptionType } =
    useSRSubscriptionPricingForm({ name, isEditMode });

  return (
    <MembershipPlanFormProvider
      regularMembershipPlansPrices={membershipPlansPrices}
      defaultPricingMode={PricingMode.Regular}
      name={getFormGroupPath(name, SRSubscriptionPricingFormFields.Pricing)}
      createInitValues={!isEditMode}
    >
      <BasicFormWrapper className={className}>
        <SectionSubTitle>
          {t('headers.pricing-and-current-capacity')}
        </SectionSubTitle>
        <Description>
          {t('phrase.this-pricing-defines-retail-prices')}
        </Description>
        <FormColumn>
          <Field
            component={SRSubscriptionMembershipPlanForm}
            disabled={disabled || !subscriptionType}
            membershipPlansPrices={membershipPlansPrices}
            {...getFieldPropertiesForGroup({
              inputId: SRSubscriptionPricingFormName,
              groupName: name,
              name: SRSubscriptionPricingFormFields.Pricing,
            })}
            subscriptionType={subscriptionType}
          />
        </FormColumn>
      </BasicFormWrapper>
    </MembershipPlanFormProvider>
  );
};

export default SRSubscriptionPricingForm;
